<template>
  <div class="divider display-22-20 pa-0 pr-3">{{ highlight }}</div>
</template>
 
<script>
export default {
  props: {
    highlight: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.divider {
  height: 31px;
  width: 100%;
  background-color: #ff7100;
  opacity: 0.93;
  color: #ffffff;
}

.round-bottom {
  -webkit-border-bottom-left-radius: 5px;
  -moz-border-bottom-left-radius: 5px;
  border-bottom-left-radius: 5px;
  -webkit-border-bottom-right-radius: 5px;
  -moz-border-bottom-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.round-top {
  -webkit-border-top-left-radius: 5px;
  -moz-border-top-left-radius: 5px;
  border-top-left-radius: 5px;
  -webkit-border-top-right-radius: 5px;
  -moz-border-top-right-radius: 5px;
  border-top-right-radius: 5px;
}

.round-corners {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  height: 57px;
  align-items: center;
  display: flex;
}

@media screen and (max-width: 600px) {
  .round-corners {
    height: 38px;
  }
}
</style>
